import React, { useState } from "react";
import { FaSearch } from "react-icons/fa";
import { FaRegTrashCan } from "react-icons/fa6";
import Swal from "sweetalert2";
import axios from "axios";


function AltaInventario() {
  const currentYear = new Date().getFullYear();
  const [masterEncontrado, setMasterEncontrado] = useState(false);
  const [busquedaRealizada, setBusquedaRealizada] = useState(false);

  const initialFormState = {
    master: "",
    vueloLlegada: "",
    anioLlegada: currentYear,
    vueloSalida: "",
    anioSalida: currentYear,
    origen: "",
    destino: "",
    etd: "",
    piezas: "",
    peso: "",
    piezasTotales: "",
    pesoTotal: "",
    volumen: "",
    descripcion: "",
    temperatura: "",
  };

  const [formData, setFormData] = useState(initialFormState);

  const years = [];

  for (let i = 2019; i <= currentYear; i++) {
    years.push(i);
  }

  const handleMasterChange = (e) => {
    let value = e.target.value;
    let numbersOnly = value.replace(/\D/g, "").slice(0, 11);

    let formatted =
      numbersOnly.length > 3
        ? `${numbersOnly.slice(0, 3)}-${numbersOnly.slice(3)}`
        : numbersOnly;

    setFormData({ ...formData, master: formatted });

    setBusquedaRealizada(false);
    setMasterEncontrado(false);
  };

  const handleBuscarMaster = async () => {
    // 1. Validación inicial: Si no hay master, no disparamos la petición

    if (!formData.master) {

      Swal.fire("Atención", "Por favor ingresa un número de Master", "info");
      return;
    }
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_URL_BACKEND_TRANSIT}/api/v1/add_extras/searchMaster`,
        {
          params: {
            awb: formData.master
          },
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          }
        }
      );
      // 2. Desestructuramos la respuesta del backend [status, data]
      const [status, data] = res.data;
      if (status === 1) {
        // 3. Mapeo de parámetros del Backend -> State del Frontend
        setFormData({
          ...formData,
          vueloLlegada: data.flightArrive,      // AM0001/04MAR
          anioLlegada: data.yearArriveSelect,   // 2026
          vueloSalida: data.flightDeparture,    // AM456
          anioSalida: data.yearExitSelect,      // 2026
          origen: data.origin,                  // MEX
          destino: data.destination,            // JFK
          etd: data.etd,                        // 12:30
          piezas: data.pieces,                  // 10
          peso: data.weight,                    // 200
          piezasTotales: data.totalPieces,      // 10
          pesoTotal: data.totalWeight,          // 200
          volumen: data.volume,                 // 3
          descripcion: data.description,        // Medicamentos
        });
        setMasterEncontrado(true);
        setBusquedaRealizada(true);

        // Opcional: Notificación de éxito

        // Swal.fire("Éxito", "Datos de Master cargados", "success");
      } else {
        // Si el status es -1 o cualquier otro
        setMasterEncontrado(false);
        setBusquedaRealizada(true);
        Swal.fire("Atención", "No se encontró información para la Master: " + formData.master, "warning");
      }
    } catch (error) {
      console.error("Error en handleBuscarMaster:", error);
      setMasterEncontrado(false);
      // Manejo de errores específicos (ej. 401, 500)
      const msg = error.response?.data?.message || "Ocurrió un error al obtener los datos";
      Swal.fire("Error", msg, "error");
    }
  };

  const temperaturas = [
    "N/A",
    "FRO: -7°C a -2°C",
    "COL: +2°C a +8°C",
    "ERT: +2°C a +25°C",
    "CRT: +15°C a +25°C",
  ];

  const handleChange = (field, value) => {
    setFormData({ ...formData, [field]: value });
  };

  const handleSave = async () => {
    try {
        // 1. Preparamos el cuerpo de la petición (Body)
        const dataToSend = {
            add_type: "1",
            awb: formData.master, // Usamos el valor del estado
            is_external: "2",
            flight_arrive: formData.vueloLlegada, // AM0026/20FEB
            year_arrive_select: formData.anioLlegada,
            flight_exit: formData.vueloSalida,
            year_exit_select: formData.anioSalida,
            origin: formData.origen,
            destination: formData.destino,
            etd: formData.etd,
            pieces: formData.piezas,
            weight: formData.peso,
            total_pieces: formData.piezasTotales,
            total_weight: formData.pesoTotal,
            volume: formData.volumen,
            description: formData.descripcion,
            required_temp: formData.temperaturaId || "2" // Asegúrate de mandar el ID
        };
         const dataToClean = {
            add_type: "",
            awb: "", // Usamos el valor del estado
            is_external: "",
            flight_arrive: "", // AM0026/20FEB
            year_arrive_select: "",
            flight_exit: "",
            year_exit_select: "",
            origin: "",
            destination: "",
            etd: "",
            pieces: "",
            weight: "",
            total_pieces: "",
            total_weight: "",
            volume: "",
            description: "",
            required_temp: "" || "" // Asegúrate de mandar el ID
        };

        // 2. Ejecutamos el POST
        const res = await axios.post(
            `${process.env.REACT_APP_URL_BACKEND_TRANSIT}/api/v1/add_extras/save`,
            dataToSend, // Segundo argumento: Datos
            {
                headers: {
                    Authorization: `Bearer ${sessionStorage.getItem("token")}`,
                }
            } // Tercer argumento: Configuración
        );

        if (res.data.status === 'success') {
            Swal.fire("Guardado", "Alta generada con éxito", "success");
            // Aquí puedes limpiar el formulario o redireccionar
            setFormData(dataToClean);
        } else {
            Swal.fire("Error", res.data.message, "error");
        }

    } catch (error) {
        console.error("Error al guardar:", error);
        const errorMsg = error.response?.data?.message || "Error interno al procesar la solicitud";
        Swal.fire("Error", errorMsg, "error");
    }
};
  const handleNumberChange = (field, value) => {
    const onlyNumbers = value.replace(/\D/g, ""); // elimina todo excepto números
    setFormData({ ...formData, [field]: onlyNumbers });
  };

  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-4 mb-3">
            <label className="fw-bold">
              <small className="size">Master *</small>
            </label>

            <div className="input-group">
              <input
                type="text"
                className="form-control"
                value={formData.master}
                onChange={handleMasterChange}
              />

              <span
                className="input-group-text"
                style={{ cursor: "pointer" }}
                onClick={handleBuscarMaster}
              >
                <FaSearch />
              </span>
              <span
                className={`input-group-text ${formData.master ? "" : "text-muted"
                  }`}
                style={{
                  cursor: formData.master ? "pointer" : "not-allowed",
                }}
                onClick={() => {
                  setFormData(initialFormState);
                  setMasterEncontrado(false);
                  setBusquedaRealizada(false);
                }}
              >
                <FaRegTrashCan />
              </span>
            </div>

            <small>
              Clic en <FaSearch /> para buscar master existente
            </small>

            {busquedaRealizada && !masterEncontrado && (
              <small className="text-danger d-block mt-1">
                No se encontro la master indicada
              </small>
            )}
          </div>

          <div className="col-md-4 mb-3">
            <label className="fw-bold">
              <small className="size">Vuelo de llegada*</small>
              <input
                type="text"
                className="form-control"
                value={formData.vueloLlegada}
                onChange={(e) => handleChange("vueloLlegada", e.target.value)}
              />
            </label>
          </div>

          <div className="col-md-4 mb-3">
            <label className="fw-bold">
              <small className="size" for="inputAnioArrival">
                Año llegada*
              </small>
              <select
                className="form-select"
                value={formData.anioLlegada}
                onChange={(e) => handleChange("anioLlegada", e.target.value)}
              >
                {years.map((year) => (
                  <option key={year} value={year}>
                    {year}
                  </option>
                ))}
              </select>
            </label>
          </div>
        </div>

        <div className="row">
          <div className="col-md-4 mb-3">
            <label className="fw-bold">
              <small className="size">Vuelo de salida*</small>
              <input
                type="text"
                className="form-control"
                value={formData.vueloSalida}
                onChange={(e) => handleChange("vueloSalida", e.target.value)}
              />
            </label>
          </div>
          <div className="col-md-4 mb-3">
            <label className="fw-bold">
              <small className="size" for="inputAnioExit">
                Año salida*
              </small>
              <select
                className="form-select"
                value={formData.anioSalida}
                onChange={(e) => handleChange("anioSalida", e.target.value)}
              >
                {years.map((year) => (
                  <option key={year} value={year}>
                    {year}
                  </option>
                ))}
              </select>
            </label>
          </div>
          <div className="col-md-4 mb-3">
            <label className="fw-bold">
              <small className="size">Origen*</small>
            </label>
            <input
              type="text"
              className="form-control"
              value={formData.origen}
              onChange={(e) => handleChange("origen", e.target.value)}
            />
          </div>
        </div>

        <div className="row">
          <div className="col-md-4 mb-3">
            <label className="fw-bold">
              <small className="size">Destino*</small>
            </label>
            <input
              type="text"
              className="form-control"
              value={formData.destino}
              onChange={(e) => handleChange("destino", e.target.value)}
            />
          </div>

          <div className="col-md-4 mb-3">
            <label className="fw-bold">
              <small className="size">ETD*</small>
            </label>
            <input
              type="time"
              className="form-control"
              value={formData.etd}
              onChange={(e) => handleChange("etd", e.target.value)}
            />
          </div>

          <div className="col-md-4 mb-3">
            <label className="fw-bold">
              <small className="size">Piezas*</small>
            </label>
            <input
              type="text"
              className="form-control"
              value={formData.piezas}
              onChange={(e) => handleNumberChange("piezas", e.target.value)}
            />
          </div>
        </div>

        <div className="row">
          <div className="col-md-4 mb-3">
            <label className="fw-bold">
              <small className="size">Peso*</small>
            </label>
            <input
              type="text"
              className="form-control"
              value={formData.peso}
              onChange={(e) => handleNumberChange("peso", e.target.value)}
            />
          </div>

          <div className="col-md-4 mb-3">
            <label className="fw-bold">
              <small className="size">Piezas Totales*</small>
            </label>
            <input
              type="text"
              className="form-control"
              value={formData.piezasTotales}
              onChange={(e) => handleNumberChange("piezasTotales", e.target.value)}
            />
          </div>

          <div className="col-md-4 mb-3">
            <label className="fw-bold">
              <small className="size">Peso Total*</small>
            </label>
            <input
              type="text"
              className="form-control"
              value={formData.pesoTotal}
              onChange={(e) => handleNumberChange("pesoTotal", e.target.value)}
            />
          </div>
        </div>

        <div className="row">
          <div className="col-md-4 mb-3">
            <label className="fw-bold">
              <small className="size">Volumen</small>
            </label>
            <input
              type="text"
              className="form-control"
              value={formData.volumen}
              onChange={(e) => handleNumberChange("volumen", e.target.value)}
            />
          </div>

          <div className="col-md-4 mb-3">
            <label className="fw-bold">
              <small className="size">Descripción*</small>
            </label>
            <input
              type="text"
              className="form-control"
              value={formData.descripcion}
              onChange={(e) => handleChange("descripcion", e.target.value)}
            />
          </div>

          <div className="col-md-4 mb-3">
            <label className="fw-bold">
              <small className="size" for="inputRequiredTemperature">
                Temperatura requerida*
              </small>
            </label>
            <select
              className="form-select"
              value={formData.temperatura}
              onChange={(e) => handleChange("temperatura", e.target.value)}
            >
              <option value="">Selecciona...</option>
              {temperaturas.map((temp, index) => (
                <option key={index} value={temp}>
                  {temp}
                </option>
              ))}
            </select>
          </div>
        </div>

        <div className="row mt-3">
          <div className="d-flex justify-content-end">
            <button className="btnn" onClick={handleSave}>
              Guardar
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

export default AltaInventario;
